import script from "./DiaHora.vue?vue&type=script&setup=true&lang=js"
export * from "./DiaHora.vue?vue&type=script&setup=true&lang=js"

import "./DiaHora.vue?vue&type=style&index=0&id=feef9a40&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feef9a40"]])

export default __exports__